export var FETCH_SOCIETY_REQUEST = 'FETCH_SOCIETY_REQUEST';
export var FETCH_SOCIETY_FAILED = 'FETCH_SOCIETY_FAILED';
export var FETCH_SOCIETY_SUCCEEDED = 'FETCH_SOCIETY_SUCCEEDED';
export var UPDATE_SOCIETY_REQUEST = 'UPDATE_SOCIETY_REQUEST';
export var UPDATE_SOCIETY_FAILED = 'UPDATE_SOCIETY_FAILED';
export var UPDATE_SOCIETY_SUCCEEDED = 'UPDATE_SOCIETY_SUCCEEDED';
export var SET_SOCIETY_STEP = 'SET_SOCIETY_STEP';
export var UPLOAD_SOCIETY_DOCUMENT_REQUEST = 'UPLOAD_SOCIETY_DOCUMENT_REQUEST';
export var UPLOAD_SOCIETY_DOCUMENT_FAILED = 'UPLOAD_SOCIETY_DOCUMENT_FAILED';
export var UPLOAD_SOCIETY_DOCUMENT_SUCCEED = 'UPLOAD_SOCIETY_DOCUMENT_SUCCEED';
export var GET_ACCT_STATUS_REQUEST = 'GET_ACCT_STATUS_REQUEST';
export var GET_ACCT_STATUS_FAILED = 'GET_ACCT_STATUS_FAILED';
export var GET_ACCT_STATUS_SUCCEED = 'GET_ACCT_STATUS_SUCCEED';
